import React, { useEffect, useState, useImperativeHandle, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import "./custom.scss";

import "./styles.scss";
import { initialData_in as initialData } from "./TableDataSet";
import { TABLE_DATA } from "util";

import update from "immutability-helper";

import Rows from "./DnDTables/DataTable";

const P_TYPE = "in";
const API = "/pcsCreate/retrieveParaInList";

const HeaderTarget = {
    inReceivingSite: "Receiving Site",
    inSendingSite: "Sending Site",
    inSetPoint: "Set Point",
    inTargetRange: "Target Range",
    inAcceptableRange: "Acceptable Range",
};

const InTable = (props, _ref) => {
    const { so, sso, autoResizeTextarea,onOpen,RevCmptCheckList } = props;
    const [Hide, setHide] = useState(false);
    const [TData, setTData] = useState([]);
    const [Header, SetHeader] = useState(HeaderTarget);

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        loadData: ({ data, header }) => {
            let newVal = [];

            //2026.02.03 luh Criticality 빈값일 때, 윗 행에 있는 값 들어가던 현상 조치
            data.forEach(d => {
                const tmparr = [];

                d.forEach(dd => {
                    // 매 dd마다 초기 데이터를 완전 복제
                    let tmp = JSON.parse(JSON.stringify(initialData));

                    Object.entries(dd).forEach(([k, v]) => {
                        const idx = tmp.findIndex(i => i.name === k);
                        if (idx > -1) {
                            // 값이 빈 문자열이라도 그대로 넣는다
                            tmp[idx].value = v;
                        }
                    });

                    // rcvCritical 가 비어 있으면 연관된 라벨도 비운다.
                    if (!dd.rcvCritical) {
                        const idx = tmp.findIndex(i => i.name === 'rcvCriticalNm');
                        if (idx > -1) tmp[idx].value = '';
                    }

                    tmparr.push(tmp);
                });

                newVal.push(tmparr);
            });

            setTData((DATA) => [...newVal]);
            SetHeader((d) => {
                let newData = {};
                Object.keys(HeaderTarget).forEach((i) => {
                    newData[i] = !!header?.[i] ? header?.[i] : HeaderTarget?.[i];
                });
                return newData;
            });
        },
    }));

    useEffect(() => {
        document.querySelectorAll("textarea").forEach((e) => {
            autoResizeTextarea(e);
        });
    }, [TData]);


    const onOpenWrapper = (vv,uniqueCode) => {
        if( vv.cmptCheck )
            onOpen(vv,uniqueCode,TData,'IN');
    }
    const HandleHide = () => {
        setHide(!Hide);
    };

    const renderFunc = useMemo(() => {
        try {
            let _sso;
            if (sso > 0) {

                _sso = so[sso];
                let remark = _sso[P_TYPE + "Remark"];
                return (
                    <React.Fragment>
                        <tr>
                            <td colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                className="name">
                                <div className={"namename"}>
                                    {_sso?.desc}
                                    {/* <div className={"code"}>{"(" + _sso?.seqCode + ")"}</div> */}
                                </div>
                            </td>
                        </tr>
                        {remark !== "FALSE" && (
                            <tr>
                                <td
                                    colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                    data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                    className="soremark"
                                >
                                    <div>{remark}</div>
                                </td>
                            </tr>
                        )}
                        {TData[sso - 1].map((v, ii) => {
                            return (
                                <Rows
                                    api={API}
                                    code={_sso.code}
                                    PROCode={_sso.code}
                                    index={ii}
                                    rowData={v}
                                    autoResizeTextarea={autoResizeTextarea}
                                    key={"in" + ii}
                                    onOpen = {onOpenWrapper}
                                    dataIndex={sso}
                                    sheetType={"I"}
                                    RevCmptCheckList={RevCmptCheckList}
                                />
                            );
                        })}
                    </React.Fragment>
                );
            } else {
                const ret = so.map((k, i) => {

                    if (!!!k.code) {
                        return null;
                    }
                    try {
                        let chk = TData[i - 1] && TData[i - 1].filter((v) => {
                            let chk2 = v.find((c) => c.name === "hide");
                            return chk2?.value !== "TRUE";
                        });
                        let remark = k[P_TYPE + "Remark"];

                        if (chk && chk.length > 0) {
                            return (
                                <React.Fragment key={i}>
                                    <tr>
                                        <td
                                            colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                            data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                            className="name"
                                        >
                                            <div className={"namename"}>
                                                {k.desc}
                                                {/* <div className={"code"}>
                                                    {"(" + k.seqCode + ")"}
                                                </div> */}
                                            </div>
                                        </td>
                                    </tr>
                                    {remark !== "FALSE" && (
                                        <tr>
                                            <td
                                                colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                                data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                                className="soremark"
                                            >
                                                <div>{remark}</div>
                                            </td>
                                        </tr>
                                    )}
                                    {!!TData &&
                                        TData[i - 1].map((v, ii) => {
                                            return (
                                                <Rows
                                                    api={API}
                                                    code={k.code}
                                                    PROCode={k.code}
                                                    index={ii}
                                                    rowData={v}
                                                    autoResizeTextarea={autoResizeTextarea}
                                                    key={"in" + ii}
                                                    onOpen = {onOpenWrapper}
                                                    dataIndex={i}
                                                    sheetType={"I"}
                                                    RevCmptCheckList={RevCmptCheckList}
                                                />
                                            );
                                        })}
                                </React.Fragment>
                            );
                        } else {
                            return null;
                        }
                    } catch (e) {
                        console.error(e);
                        return null;
                    }
                });
                return ret;
            }
        } catch (e) {
            console.error(e);
            return null;
        }
    }, [TData, so, sso, RevCmptCheckList]);

    return (
        <section className="detail">
            <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                    Operational Parameter <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className={"data_table"}>
                    <table className="bpl-table-default">
                        {TABLE_DATA?.header?.[P_TYPE](Header, true)}
                        <tbody>{renderFunc}</tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default React.memo(React.forwardRef(InTable));
